import { invalidateQueriesGlobally } from '@/utils/queries/invalidateQueriesGlobally'
import { useEffect, useRef } from 'react'

export function useCrosschainSuccessHandler({
  crosschainTransactionStatus,
  crosschainTransactionId,
  inputAmount,
  setTransactionFinished,
}: {
  crosschainTransactionStatus: { status: string } | undefined
  crosschainTransactionId: string | undefined
  inputAmount: string
  setTransactionFinished: ({ txHash, amount }: { txHash: string | undefined; amount: string }) => void
}) {
  const hasHandledSuccessRef = useRef(false)

  useEffect(() => {
    if (!crosschainTransactionStatus?.status) return

    if (crosschainTransactionStatus.status === 'success' && !hasHandledSuccessRef.current) {
      hasHandledSuccessRef.current = true
      invalidateQueriesGlobally()
      setTransactionFinished({ txHash: crosschainTransactionId, amount: inputAmount })
    }
  }, [crosschainTransactionStatus?.status, crosschainTransactionId, inputAmount, setTransactionFinished])

  useEffect(() => {
    if (!crosschainTransactionId) {
      hasHandledSuccessRef.current = false
    }
  }, [crosschainTransactionId])
}
